import { AutogenModelOrderCurrentMoveStops, AutogenRowOrderCurrentMoveStops } from "./autogen/AutogenModelOrderCurrentMoveStops";

export class ModelOrderCurrentMoveStops extends AutogenModelOrderCurrentMoveStops<RowOrderCurrentMoveStops> {
	constructor() {
		super(RowOrderCurrentMoveStops);
	}
}

export class RowOrderCurrentMoveStops extends AutogenRowOrderCurrentMoveStops {
}